import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core'
import { QuoteCartService } from '../../quote-services/quote-cart.service'
import {
  AuthService,
  User,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { switchMap, take } from 'rxjs/operators'
import { of, Observable } from 'rxjs'
import { Router } from '@angular/router'

@Component({
  standalone: false,
  selector: 'vs-empty-cart',
  templateUrl: './empty-cart.component.html',
  styleUrls: ['./empty-cart.component.scss'],
})
export class EmptyCartComponent implements OnInit {
  @Input() cartId
  @Output() emptycart = new EventEmitter<string>()
  public cartStatus
  public userType
  user$: Observable<User>
  loggedIn: boolean
  constructor(
    private router: Router,
    private quoteService: QuoteCartService,
    private auth: AuthService,
    public globalMessageService: GlobalMessageService
  ) {}
  ngOnInit(): void {
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.userType = 'current'
        } else {
          this.userType = 'anonymous'
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.cartId = sessionStorage.getItem('cartId-' + this.userType)
    this.cartStatus = sessionStorage.getItem('cartStatus-' + this.userType)
    this.quoteService
      .getCart(this.cartId, this.userType)
      .pipe(take(1))
      .subscribe(
        (cart) => {
          if (cart['entries'].length < 1) {
            this.cartStatus = 'empty'
          }
          sessionStorage.setItem('cartStatus-' + this.userType, this.cartStatus)
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    if (this.cartStatus) {
      this.emptycart.emit(this.cartStatus)
      return
    }
    if (!this.cartStatus || this.cartStatus === '') {
      return
    }
  }
  goToAddProduct() {
    this.quoteService
      .getCart(this.cartId, this.userType)
      .pipe(take(1))
      .subscribe(
        (success) => {
          this.cartStatus = 'adding'
          if (this.userType === 'current') {
            this.cartId = success['code']
          } else if (this.userType === 'anonymous') {
            this.cartId = success['guid']
          }
          sessionStorage.setItem('cartId-' + this.userType, this.cartId)
          sessionStorage.setItem('cartStatus-' + this.userType, this.cartStatus)
          this.emptycart.emit(this.cartStatus)
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  goToBulkOrder(){
    sessionStorage['selectedIndex'] = 1;
    this.router.navigate(['/bulk-Order']);
  }
}
